import PropTypes from 'prop-types';
import Icon from './Icon';

// The wait disclaimer, wherever something is sent to the television.
//
// Nothing on the phone moves when a setting is saved or the recitation is
// toggled: the value goes to the server, and the box collects it on its own
// poll. Left unsaid, that honest sequence reads as a broken app -- the customer
// flips the switch, watches their living room not change, and flips it back.
//
// So it is coloured rather than muted. A grey footnote is read after the
// waiting, which is too late to have set any expectation; this one has to be
// seen before the switch is pressed. Gold rather than the warning red, because
// nothing is wrong -- the box is simply not instantaneous.
const Note = ({ children, className = '' }) => (
  <p className={'note' + (className ? ` ${className}` : '')}>
    <Icon name="refresh" size={14} className="note__icon" />
    <span>{children}</span>
  </p>
);

Note.propTypes = {
  children:  PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default Note;
